<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :isEditing="true"
            @save-item="updateItem">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Account werd niet gewijzigd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/account';
    import ItemForm from './FormMijnAccount';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                model: {},
            };
        },
        created () {
            api.getDetailMijnAccount().then((response) => {
                this.model = response.data.model;
            });
        },
        methods: {
            updateItem (model) {
                api.updateMijnAccount(model).then(() => {
                    this.$store.dispatch('changeName', model);
                    this.$router.replace('/home');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/account/EditMijnAccount.vue